import React from 'react'
import { RxCross2, HiUser, HiUsers } from 'react-icons/rx';
import { AiOutlineCheck } from 'react-icons/ai';
import { Link } from 'react-router-dom';

import Logo from '../../assets/Images/logo.png';
const Instructions = (props) => {
    const { setInstruction, setGiocatori, setDificolta, setLoss } = props;

    const next = () => {
        setInstruction(false)
        setLoss(false)
        setGiocatori(false)
        setDificolta(false)
    }
    return (
        <div>
            <div className=" instructionHeader">
                <div className="header_inner_div Gamberoni_header">
                    <div>
                      <RxCross2 className="icons_size" color="black" size={30} onClick={next} /> 

                    </div>
                    <div>
                        <h4 className='NUOVA_PARTITA_text' onClick={next} >NUOVA PARTITA</h4>
                    </div>
                </div>
            </div>
            <div className="instruction_smartphone_div">
                <p className='OTTIMIZZATO'>GAMBERONI È OTTIMIZZATO SUL CELLU</p>
                <span className='instruction_smartphone_text'>gioca con il tuo smartphone!</span>
            </div>

            {/* after 1000px smartphone section */}
            <div className="instruction_main_section">
                <div className='instruction_text_section'>
                    <h1 className='instruction_text_GAMBERONI'>GAMBERONI</h1>
                    <h5 className='instruction_text_paragraph'>è il quiz che va al contrario!</h5>
                    {/* <Link to='/'>    <button className='instruction_Nuova_partita'>NUOVA PARTITA</button></Link>   */}
                    <button className='instruction_Nuova_partita' onClick={next}>NUOVA PARTITA</button>


                </div>

                <div className="All_instruction_main_div">
                    <div className="instructionInner">
                        <div className='quanti_main_section'>
                            <h4 className='h4_heading'>In quanti si gioca?</h4>
                            <p>A coppie, da 2 a infiniti giocatori.</p>
                        </div>
                        <div className='Comesigioca_main_section'>
                            <h4 className='h4_heading'>Come si gioca?</h4>
                            <p>Alla prima domanda si risponde con GAMBERONI, dopodichè si risponde sempre con la risposta alla domanda precedente.</p>
                            <p>Un giocatore tiene lo smartphone, fa le domande, controlla le risposte e schiaccia i bottoni, l'altro risponde alle domande.</p>
                        </div>

                        <div className='game_features_div'>
                            <div className='game_features_Time_Main'>
                                <div className='game_features_Time_div'>
                                    <h4 className='h4_heading gameFeatureh4'>15</h4>
                                    <p>domande</p>
                                </div>
                                <div className='game_features_Time_div'>
                                    <h4 className='h4_heading gameFeatureh4'>1:30</h4>
                                    <p>minuti di tempo</p>
                                </div>
                                <div className='game_features_Time_div'>
                                    <h4 className='h4_heading gameFeatureh4'>3</h4>
                                    <p>secondi a risposta</p>
                                </div>
                            </div>

                            <div>
                                <ul>
                                    <li>Se si sbaglia, si ricomincia da capo.</li>
                                    <li>Se il risponditore dopo 3 secondi non risponde, si clicca sul pulsante X e si ricomincia da capo.</li>
                                    <li>Sono accettate come risposte corrette i sinonimi delle risposte.</li>
                                    <li>Se il giocatore non conosce le risposta ad una domanda, questa gli viene rivelata ma si riparte da capo.</li>

                                </ul>
                            </div>
                            <div className='game_features_Time_Main'>
                                <div className='game_features_icon_div'>
                                    <div className='crossGameFeatureIcon'><RxCross2 size={25} className='crossFeatureIcon' />  </div>
                                    <p>risposta errata e si ricomincia da capo</p>
                                </div>
                            </div>
                            <div className='game_features_Time_Main'>
                                <div className='game_features_icon_div'>
                                    <div className='crossGameFeatureIcon checkIcon'><AiOutlineCheck size={25} color='white' className='crossFeatureIcon' />  </div>
                                    <p>risposta errata e si ricomincia da capo</p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div className='Gamberoni_born'>
                    <div>
                        <h1>Ma dove nasce Gamberoni?</h1>
                        <p>Da un’idea di Rocco Tanica, musicista, autore e tastierista del gruppo Elio e le Storie Tese. Gamberoni viene proposto al pubblico per la prima volta nel 2013 durante la 20esima stagione di Cordialmente, programma radiofonico in onda dal 1993 su Radio Deejay, condotto da Linus ed Elio e le Storie Tese.zz</p>

                    </div>
                    <div className='Gamberoni_born_btn'>
                        <button className='instruction_Nuova_partita' onClick={next}>NUOVA PARTITA</button>

                    </div>
                </div>
                <div className="footer">
                    <p><span className='Logo'>Logo:</span> creato da Septian Kho di Noun Project</p>
                </div>
            </div>
        </div>
    )
}

export default Instructions
